import apisauce from "apisauce";
import { getApiGatewayUrl } from "common/helper";
import { NO_CACHE_HEADERS } from "constants/headers";

var Singleton = (function () {
    var instance;

    function createInstance() {
        return apisauce.create({
            baseURL: getApiGatewayUrl(),
            cache: "no-store",
            headers: {
                ...NO_CACHE_HEADERS,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            timeout: 150000,
        });
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        },
    };
})();

export default Singleton.getInstance();
